import { create } from 'zustand';

const useSearchInputStore = create((set) => ({
  searchInput: '',
  setSearchInput: (newInput) => set({ searchInput: newInput }),
  resetSearchInput: () => set({ searchInput: '' }),
}));

export default useSearchInputStore;
